<template>
    <el-card class="left-part">
        <h4>用户信息组件</h4>
        <div class="button-list">
            <el-Button
             v-for="(item, index) in userComponents"
             :key="index"
             @click="selectCompontent(item)">
             {{item.title}}
            </el-Button>
        </div>
        <h4>自定义组件</h4>
        <div class="button-list">
            <el-Button
             v-for="(item, index) in customComponents"
             :key="index"
             @click="selectCompontent(item)">
             {{item.title}}
            </el-Button>
        </div>
    </el-card>
</template>

<script>
export default {
    data() {
        return {
            // 用户信息组件
            userComponents: [
                {
                    name: 'realName',
                    title: '姓名',
                    showTitle: '姓名',
                    limitLength: 20,
                    type: 1, // 自定义字段的类型（1：字符串类型 2：布尔类型 3：日期时间类型 4：数字类型 5:单选 6：多选）
                    comment: '请输入您的姓名',
                    unique: true
                },
                {
                    name: 'sex',
                    title: '性别',
                    showTitle: '性别',
                    type: 2,
                    unique: true
                },
                {
                    name: 'phone',
                    title: '手机',
                    showTitle: '手机',
                    limitLength: 11,
                    type: 4,
                    comment: '请输入您的手机号',
                    unique: true
                },
                {
                    name: 'jobTitle',
                    title: '职称',
                    showTitle: '职称',
                    type: 1,
                    comment: '请选择您的职称',
                    unique: true
                },
                {
                    name: 'department',
                    title: '科室',
                    showTitle: '科室',
                    type: 1,
                    comment: '请选择您的科室',
                    unique: true
                },
                {
                    name: 'hospital',
                    title: '所在医院',
                    showTitle: '所在医院',
                    type: 1,
                    comment: '请选择您所在医院',
                    unique: true
                },
                {
                    name: 'idcard',
                    title: '身份证号',
                    showTitle: '身份证号',
                    limitLength: 18,
                    type: 4,
                    comment: '请输入您的身份证号',
                    unique: true
                },
                {
                    name: 'certificatePhoto',
                    type: 1,
                    title: '上传证件照',
                    showTitle: '上传执/职业证件照',
                    unique: true
                }
            ],
            // 自定义组件
            customComponents: [
                {
                    name: 'text',
                    title: '单行文本框',
                    showTitle: '单行文本框',
                    limitLength: 50,
                    limitUser: 3,
                    type: 1,
                    comment: '请输入...'
                },
                {
                    name: 'choice',
                    title: '选择题',
                    showTitle: '选择题',
                    type: 5,
                    contents: []
                },
                {
                    name: 'address',
                    title: '地址',
                    showTitle: '地址',
                    type: 1,
                    isHospitalAddress: 0,
                    isFullAddress: 0
                }
            ],
            // 共有数据
            same: {
                isRequired: 0 // 是否必填
            }
        }
    },
    methods: {
        // 选择了组件
        selectCompontent(item) {
            for(let key in this.same) {
                this.$set(item, key, this.same[key])
            }
            this.$set(item, 'chName', item.showTitle)
            this.$emit('addComponents', item)
        }
    }
}
</script>

<style type="text/less" lang="less" scoped>
    .left-part{
        height: 670px;
        align-self: baseline;
    }
    .button-list{
        /deep/.el-button{
            min-width: 112px;
            margin: 0 10px 10px 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/operateManage/signupform/components/leftPart.vue